import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../Dropdown/index.scss';
import './index.scss';

const SearchableDropdown = ({
  label,
  placeholder = 'Search...',
  options = [],
  name,
  value,
  handleChange,
  id,
  errorText = '',
}) => {
  const [inputText, setInputText] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  // Derive filtered list directly — no useEffect timing gap
  const filteredOptions = useMemo(() => {
    if (!inputText) return options;
    return options.filter((opt) =>
      opt.label?.toLowerCase().includes(inputText.toLowerCase())
    );
  }, [inputText, options]);

  // Sync display text when value or options change (handles reset and edit mode)
  useEffect(() => {
    if (!value && value !== 0) {
      setInputText('');
      return;
    }
    const match = options.find((opt) => String(opt.value) === String(value));
    if (match) {
      setInputText(match.label);
    }
  }, [value, options]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setInputText(option.label);
    setShowDropdown(false);
    handleChange && handleChange({ target: { id, name, value: option.value } });
  };

  const handleInputChange = (e) => {
    const text = e.target.value;
    setInputText(text);
    setShowDropdown(true);
    if (!text) {
      handleChange && handleChange({ target: { id, name, value: '' } });
    }
  };

  return (
    <div className='cdropdown searchable-dropdown' ref={wrapperRef}>
      {label && <label className='tooltip-on-hover'>{label}</label>}
      <input
        type='text'
        className='form-input'
        placeholder={placeholder}
        value={inputText}
        onChange={handleInputChange}
        onFocus={() => setShowDropdown(true)}
        onClick={() => setShowDropdown(true)}
        autoComplete='off'
      />
      {showDropdown && (
        <ul className='searchable-dropdown__list'>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <li
                key={option.value}
                onMouseDown={() => handleSelect(option)}
                className='searchable-dropdown__item'
              >
                {option.label}
              </li>
            ))
          ) : (
            <li className='searchable-dropdown__item searchable-dropdown__item--empty'>
              No results found
            </li>
          )}
        </ul>
      )}
      {errorText && <p className='loginWrapper-valid-text'>{errorText}</p>}
    </div>
  );
};

export default SearchableDropdown;
